import { LogLevel } from "@azure/msal-browser";

// SIMPLE ENVIRONMENT CONFIGURATION
// Just uncomment the environment you want to use and comment out the others

// For LOCAL development (localhost:3000)
const localConfig = {
  clientId: "f203e07f-e544-445a-965d-15873c8fe6ca",
  redirectUri: "http://localhost:3000/auth/callback",
  postLogoutRedirectUri: "http://localhost:3000"
};

// For DEVELOPMENT environment (Azure Dev)
const devConfig = {
  clientId: "f203e07f-e544-445a-965d-15873c8fe6ca",
  redirectUri: "https://app-web-drweb-dev-southafricanorth-zcy.azurewebsites.net/auth/callback",
  postLogoutRedirectUri: "https://app-web-drweb-dev-southafricanorth-zcy.azurewebsites.net"
};

// For PRODUCTION environment (Azure Prod)
const prodConfig = {
  clientId: "794786d2-75b1-4211-80f4-0cba6cd701d7",
  redirectUri: "https://app-web-drweb-prod-southafricanorth-yd5-hya7fsepfybxhdem.southafricanorth-01.azurewebsites.net/auth/callback",
  postLogoutRedirectUri: "https://app-web-drweb-prod-southafricanorth-yd5-hya7fsepfybxhdem.southafricanorth-01.azurewebsites.net"
};

// For TEST environment (research.test.hlthiq.com)
const testConfig = {
  clientId: "f203e07f-e544-445a-965d-15873c8fe6ca",
  redirectUri: "https://research.test.hlthiq.com/auth/callback",
  postLogoutRedirectUri: "https://research.test.hlthiq.com"
};

// For PRODUCTION environment (research.hlthiq.com)
const prodHlthiqConfig = {
  clientId: "794786d2-75b1-4211-80f4-0cba6cd701d7",
  redirectUri: "https://research.hlthiq.com/auth/callback",
  postLogoutRedirectUri: "https://research.hlthiq.com"
};

// CHANGE THIS LINE: Uncomment the environment you want to use
// const currentConfig = localConfig;        // For local development
// const currentConfig = devConfig;       // For development environment
// const currentConfig = prodConfig;      // For production environment (Azure)
// const currentConfig = testConfig;      // For test environment (research.test.hlthiq.com)
const currentConfig = prodHlthiqConfig;    // For production environment (research.hlthiq.com)
// 
// Log current configuration for debugging
console.log(`[MSAL Config] Using configuration:`, currentConfig);
console.log(`[MSAL Config] Current URL: ${window.location.href}`);
console.log(`[MSAL Config] Client ID: ${currentConfig.clientId}`);
console.log(`[MSAL Config] Redirect URI: ${currentConfig.redirectUri}`);

export const msalConfig = {
  auth: {
    clientId: currentConfig.clientId,
    authority: "https://login.microsoftonline.com/56fd4d88-5e07-4fdf-bb27-919c6c505e1e",
    redirectUri: currentConfig.redirectUri,
    postLogoutRedirectUri: currentConfig.postLogoutRedirectUri,
    navigateToLoginRequestUrl: false,
    clientCapabilities: ["CP1"] // This indicates SPA capabilities
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            console.log(message);
            return;
        }
      }
    },
    allowNativeBroker: false, // Disables WAM Broker
    windowHashTimeout: 90000, // Increased timeout for popup
    iframeHashTimeout: 10000, // Increased iframe timeout
    loadFrameTimeout: 0,
    tokenRenewalOffsetSeconds: 300 // Renew tokens 5 minutes before expiry
  }
};

export const loginRequest = {
  scopes: ["User.Read", "openid", "profile", "email"],
  prompt: "select_account",
  redirectUri: currentConfig.redirectUri
};

export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};

// Move any code that uses setUser, user, login, logout, or loginWithMicrosoft to your AuthContext.js file.
